import comp from "./MicrosoftLoginBtn";
export default comp;
